var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTableCombination = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 42 42",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Table-Combination_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  d: "M14 14h14v14H14V14Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M14 14h10.5a3.5 3.5 0 0 1 3.5 3.5V28h10.5a3.5 3.5 0 0 0 3.5-3.5v-21A3.5 3.5 0 0 0 38.5 0h-21A3.5 3.5 0 0 0 14 3.5V14Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M28 28H17.5a3.5 3.5 0 0 1-3.5-3.5V14H3.5A3.5 3.5 0 0 0 0 17.5v21A3.5 3.5 0 0 0 3.5 42h21a3.5 3.5 0 0 0 3.5-3.5V28Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Table-Combination_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h42v42H0z"
})))));
SvgTableCombination.viewBox = '0 0 42 42';
const ForwardRef = /*#__PURE__*/forwardRef(SvgTableCombination);
export default ForwardRef;